<template>
  <div>
    <ProgressTracker></ProgressTracker>
    <div class="container" v-if="valid">
      <Intro></Intro>
      <Rules></Rules>
      <hr>
      <form id="survey" class="form">
        <AboutYou></AboutYou>
        <hr>
        <Nomination></Nomination>
        <WriteIn></WriteIn>
        <hr>
        <Signature></Signature>
        <Submit></Submit>
      </form>
    </div>
    <section id="expired" class="section has-text-centered" v-else>
      <div class="container">
        <h1 class="title is-size-1">
          Voting has expired!
        </h1>
      </div>
    </section>
  </div>
</template>

<script>
import Intro from '@/components/Intro.vue';
import Rules from '@/components/Rules.vue';
import AboutYou from '@/components/AboutYou.vue';
import Nomination from '@/components/Nomination.vue';
import Signature from '@/components/Signature.vue';
import Submit from '@/components/Submit.vue';
import WriteIn from '@/components/WriteIn.vue';
import ProgressTracker from '@/components/ProgressTracker.vue';

export default {
  components: {
    Intro,
    Rules,
    AboutYou,
    Nomination,
    Signature,
    Submit,
    WriteIn,
    ProgressTracker,
  },
  computed: {
    valid() {
      return new Date() < new Date(this.$store.state.expiration_date);
    },
  },
};
</script>
